module.exports = __webpack_public_path__ + "img/youtube.24f9217f.png";